module.exports = __webpack_public_path__ + "img/icon-copy-default.887e685a.svg";